import { Tooltip } from '@mui/material';

type ConditionalTooltipProps = {
  title?: string;
  children: any;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}
const ConditionalTooltip = ({ title, children, placement }: ConditionalTooltipProps) => {
  if (title) {
    return (
      <Tooltip
        title={title}
        arrow
        placement={placement}
      >
        { children }
      </Tooltip>
    );
  }
  return (
    <>
      { children }
    </>
  );
};

export default ConditionalTooltip;
